<style scoped lang="scss">

    $primary: #DFA877;

    a{

        &.no-blend-mode{
             mix-blend-mode: unset !important;
             color:#000 !important;

            &:hover{
                color: $primary !important;
            }

         }

    }

</style>

<template>
    <div class="navbar_right-side d-flex align-items-center">
        <a :href="'/'+lang+'/shop'" class="mr-4 text-theme-color text-primary-hover d-none d-md-block text-decoration-none shop-menu-link" :class="{'no-blend-mode' : menu_open}">SHOP</a>
        <div class="navbar_bordered-container navbar_bordered-container--rounded-left d-flex align-items-center py-1 pr-1 pl-0 cursor-pointer" @click="openCart">
            <div class="navbar_icon-link slightly-smaller my-1">
                <div class="mr-0">
                    <span class="h6 text-theme-color" :class="{'text-darkest' : theme == 'dark'}">
                        {{counter}}
                    </span>
                </div>
            </div>
            <div class="navbar_icon-separator"></div>
            <div class="navbar_icon-link my-1">
                <div class="ml-0 mr-2">
                    <a class="d-flex" href="javascript:void(0)">
                        <!--<span class="cart_qty" v-text="counter" v-if="counter > 0"></span>-->
                        <img :src="'/images/cart-' + theme + '.svg'" alt="icona" />
                    </a>
                </div>
            </div>
            <div class="corner"></div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['initCounter', 'cartLink', 'themeProp', 'lang'],
        data() {
            return {
                counter: 0,
                theme: this.themeProp,
                theme_memo: this.themeProp,
                separated_colors: false,
                menu_open: false,
            }
        },
        mounted() {
            this.counter = parseInt(this.initCounter);

            if(this.themeProp.split('-').length > 1) {
                this.theme = this.findBreakpointTheme();
                this.theme_memo = this.theme;
                this.$eventHub.$emit('themeChange', this.theme);
            }

            if(this.themeProp.split('_').length > 1) {
                this.theme = this.themeProp.split('_')[2];
                this.theme_memo = this.theme;
                this.separated_colors = true;
            }

            this.$eventHub.$on('themeChange', (payload) => {
                this.theme = payload;
                this.theme_memo = this.theme;
            });

            this.$eventHub.$on('menuIsOpen', (payload) => {
                if(payload.open) {
                    let time = payload.mobile ? 350 : 10
                    setTimeout(() => {
                        this.theme = 'dark';
                        this.menu_open = true;
                    }, time)
                    return
                }
                let time = payload.mobile ? 10 : 550
                setTimeout(() => {
                    this.theme = this.theme_memo;
                    this.menu_open = false;
                }, time)
            });

            this.$eventHub.$on('cart.added', payload => {
                this.counter = parseInt(payload.count);
            });

            this.$eventHub.$on('cart.updated.simpleQty', payload => {
                this.counter = payload;
            });
        },
        methods: {
            findBreakpointTheme() {
                let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
                let res = null;
                let themes = this.themeProp.split('-');
                if (vw < 576){
                    res = 0;
                }else if (vw >= 576 && vw < 768) {
                    res = 1;
                }else if (vw >= 768 && vw < 992) {
                    res = 2;
                }else if (vw >= 992 && vw < 1199) {
                    res = 3;
                }else if (vw >= 1200) {
                    res = 4;
                }
                return themes[res];
            },
            openCart() {
                let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
                if(vw < 992 || this.counter == 0 || document.querySelectorAll('.side-menu').length <= 0) {
                    window.location.href = this.$root.langRoute('/carrello');
                }else{
                    this.$eventHub.$emit('cart.show', {});
                }
            },
        },
        beforeDestroy() {
            this.$eventHub.$off('cart.added');
            this.$eventHub.$off('cart.updated.simpleQty');
        },
    }
</script>
